
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/people",
      function () {
        return require("private-next-pages/people/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/people"])
      });
    }
  